module.exports = require("stream");


//////////////////
// WEBPACK FOOTER
// external "stream"
// module id = 48
// module chunks = 0